import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockFaqBlockFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: not on the critical rendering path. Both
 * `component` and `innerComponent` must be async — the renderer passes
 * `innerComponent` through as a prop, so a static import here would keep the
 * whole block in the eager entry chunk.
 */
export const faqBlockConfig = {
  name: 'inner-block-faq',
  component: defineAsyncComponent(() => import('./CmsFAQBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./FaqBlock.vue')),
  fields: blockFaqBlockFields,
} satisfies ModularBlockConfig;
